import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=d8b6e03c&scoped=true"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"
import style0 from "./signup.vue?vue&type=style&index=0&id=d8b6e03c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b6e03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8b6e03c')) {
      api.createRecord('d8b6e03c', component.options)
    } else {
      api.reload('d8b6e03c', component.options)
    }
    module.hot.accept("./signup.vue?vue&type=template&id=d8b6e03c&scoped=true", function () {
      api.rerender('d8b6e03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/signup.vue"
export default component.exports